var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB5A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.79 25.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-B5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.52,7.46l.8-1.67c.2-.41.4-.82.61-1.22.34-.7.69-1.41,1.05-2.11l.4-.79L16.46,7.8c.38.75.62,1.2,1.56,1.34l.83.12,2.83.41,3.47.51h0c-.23.26-.52.53-.74.75-.56.56-1.13,1.11-1.7,1.65l-1.07,1-.87.83a9,9,0,0,0-1.21,1.27l-.27.48L20.64,24l-.33-.1-1.48-.78-5.44-2.85-6.6,3.46c-.17.09-.43.25-.65.36h0l.51-3L7,19.21l.4-2.34a1.68,1.68,0,0,0-.52-1.61L5.44,13.89,1.6,10.17c.29-.06.83-.11,1-.13,2-.3,4.05-.61,6.07-.89A1.68,1.68,0,0,0,10.23,8c.1-.19.19-.37.28-.57Zm7.3-.35L14.5.49A1.47,1.47,0,0,0,12.38.41C12.17.63,10.91,3.16,10,5.13c-.32.66-.6,1.26-.82,1.68-.11.24-.21.42-.26.53-.14.29,0,.26-.41.3-2,.27-4,.59-6.08.89-.72.1-1.61.09-2.08.71a1.48,1.48,0,0,0,.19,2L4.37,15l1.41,1.38c.1.09.09.1.07.24L5.45,19,5.13,20.8l-.55,3.3A1.43,1.43,0,0,0,5,25.22l1,.41c.44.08,1.21-.43,1.54-.59L13.4,22l5.45,2.86.88.46,1.11.36a1.31,1.31,0,0,0,.84-.28,1.54,1.54,0,0,0,.55-1.25l-.55-3.24-.74-4.38c0-.05.31-.33.74-.74,1.51-1.46,4.81-4.57,4.93-4.88a1.55,1.55,0,0,0,0-1.39,1.5,1.5,0,0,0-1.27-.8l-3.69-.54-2.83-.41-.59-.09c-.28,0-.23-.1-.44-.52Z",
    transform: "translate(-0.01 0)",
    fill: "#ffffff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB5A);
export default __webpack_public_path__ + "static/media/B5A.c1af3ccac51f81b40cc165d9b67e59c1.svg";
export { ForwardRef as ReactComponent };